// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.D3BackgroundDrawing.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { d3 } from '../Izenda.D3Wrapper';
import { LAYOUT_CLASSES } from 'logic/data/Izenda.D3VizEngineConstants';

/**
 * Draw background
 * @param {*} svgSelection
 * @param {*} width
 * @param {*} height
 * @param {*} plotWidth
 * @param {*} plotHeight
 * @param {*} transformValue
 * @param {*} options
 */
export function drawBackground(
  svgSelection: d3.Selection,
  width: Number,
  height: Number,
  plotWidth: Number,
  plotHeight: Number,
  transformValue: String,
  options: Object
) {
  const {
    chart: { plotBackgroundColor, backgroundColor }
  } = options;

  svgSelection
    .append('g')
    .classed(LAYOUT_CLASSES.background.class, true)
    .datum(LAYOUT_CLASSES.background)
    .append('rect')
    .attr('width', width)
    .attr('height', height)
    .attr('fill', backgroundColor || 'none');

  svgSelection
    .append('g')
    .classed(LAYOUT_CLASSES.plotBackground.class, true)
    .datum(LAYOUT_CLASSES.plotBackground)
    .append('rect')
    .attr('width', plotWidth)
    .attr('height', plotHeight)
    .attr('transform', transformValue)
    .attr('fill', plotBackgroundColor || 'none');
}



// WEBPACK FOOTER //
// ./ui/share/components/charting/d3/commonDrawing/Izenda.D3BackgroundDrawing.js